import { UrlId } from '../types';

export function handleUrlId<Return>(id: UrlId, callback: (id: UrlId) => Promise<Return>) {
  return typeof id === 'undefined' ? Promise.reject(new Error('Invalid id')) : callback(id);
}
